import { computedAsync, StorageSerializers, useStorage } from '@vueuse/core'

import { DualScreen } from '@/integrations/secondscreen/plugin'
import type { Bill, BillWithPayments } from '@/types'

const STORAGE_KEY = 'customer-display'

const currentBill = useStorage<Bill | BillWithPayments | null>(STORAGE_KEY, null, undefined, {
  writeDefaults: false,
  serializer: StorageSerializers.object
})

export const useCustomerDisplay = () => {
  function updateBill(bill: Bill | BillWithPayments | null) {
    currentBill.value = bill
  }

  function clearDisplay() {
    currentBill.value = null
  }

  async function checkSecondaryDisplay() {
    try {
      const result = await DualScreen.getDisplays()
      return result.count > 1
    } catch {
      return false
    }
  }

  async function showSecondaryDisplay() {
    if (!(await checkSecondaryDisplay())) return
    try {
      await DualScreen.showSecondaryScreen()
    } catch {
      // Do nothing
    }
  }

  async function hideSecondaryDisplay() {
    try {
      await DualScreen.hideSecondaryScreen()
    } catch {
      // Do nothing
    }
  }

  const isSecondaryDisplaySupported = computedAsync(() => checkSecondaryDisplay())

  return {
    currentBill,
    isSecondaryDisplaySupported,

    updateBill,
    clearDisplay,
    showSecondaryDisplay,
    hideSecondaryDisplay
  }
}
